import { NavLink, useLocation } from 'react-router-dom';
import { useHapticFeedback } from '@/shared/hooks/useHapticFeedback';

const navItems = [
  { path: '/', label: 'Главная', icon: '🏠' },
  { path: '/study', label: 'Учёба', icon: '📚' },
  { path: '/words', label: 'Слова', icon: '📝' },
  { path: '/grammar', label: 'Грамматика', icon: '📖' },
  { path: '/profile', label: 'Профиль', icon: '⚔️' },
];

export function BottomNav() {
  const { selection } = useHapticFeedback();
  const location = useLocation();

  const handleItemClick = (path: string) => {
    selection();
    if (path === '/' && location.pathname === '/') {
      window.dispatchEvent(new CustomEvent('2enbota:home-tab-tap'));
    }
  };

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'var(--bottom-nav-height)',
        background: 'var(--theme-bg-elevated)',
        borderTop: '1px solid var(--theme-border)',
        display: 'flex',
        alignItems: 'center',
        paddingBottom: 'var(--safe-area-bottom)',
        zIndex: 100,
      }}
    >
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/'}
          onClick={() => handleItemClick(item.path)}
          data-tour-target={item.path === '/study' ? 'nav-study' : undefined}
          style={({ isActive }) => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            padding: '8px 4px',
            textDecoration: 'none',
            color: isActive ? 'var(--theme-primary)' : 'var(--theme-text-secondary)',
            transition: 'color 0.18s ease, transform 0.18s ease',
            transform: isActive ? 'scale(1.04)' : 'scale(1)',
            minHeight: '44px',
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
          })}
        >
          <span style={{ fontSize: 20, transition: 'transform 0.18s ease' }}>{item.icon}</span>
          <span style={{ fontSize: 10, fontWeight: 600 }}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
